import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import GamePage from './game.jsx';
import { useUser } from '../UserContext.js';
import { db } from '../auth.js';
import { doc, getDoc } from "firebase/firestore";

const PlayPage = ({ mode = 'shared' }) => {
    const user = useUser();
    const navigate = useNavigate();
    const params = useParams();
    const projectId = params.project;
    const ownerFromParams = params.owner;
    const isPlayRoute = mode === 'play';
    const ownerId = isPlayRoute ? user?.uid : ownerFromParams;
    const [info, setInfo] = useState({ userName: '', projectName: '' });

    useEffect(() => {
        if (!projectId) {
            navigate('/', { replace: true });
            return;
        }

        if (isPlayRoute) {
            if (!user) {
                navigate('/signin', { replace: true });
            }
            return;
        }

        if (!ownerId) {
            navigate('/', { replace: true });
            return;
        }

        const takeData = async () => {
            const projectRef = doc(db, 'user', ownerId, 'project', projectId);
            const projectSnap = await getDoc(projectRef);
            if (projectSnap.exists() && projectSnap.data().release) {
                const userDoc = await getDoc(doc(db, 'user', ownerId));
                setInfo({ userName: userDoc.data().name, projectName: projectSnap.data().name });
            } else {
                navigate('/', { replace: true });
            }
        };

        takeData().catch((err) => {
            console.log(err);
        });
    }, [projectId, ownerId, isPlayRoute, navigate, user]);

    const canRenderGame = Boolean(projectId && ownerId);

    return (
        <div className='container'>
            {!isPlayRoute && (
                <div className='game-info'>
                    <h1>{info.projectName}</h1>
                    <h3>{info.userName}</h3>
                    <div className='game-refresh'>
                        <button onClick={() => { location.reload(); }}>
                            <i className="fa fa-repeat" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            )}
            {canRenderGame && <GamePage uid={ownerId} projectId={projectId} />}
            {isPlayRoute && ownerId && (
                <div className='container-btn-group'>
                    <Link to={`/edit/${projectId}`} className="container-btn">
                        <img src="../image/icon_edit.png" alt="" />
                        <span className="tooltiptext">
                            Edit
                        </span>
                    </Link>
                </div>
            )}
        </div>
    );
};

export default PlayPage;
